<template>
  <div>
    <ThemeEditor />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ThemeEditor from '@/components/clients/ThemeEditor'

export default {
  name: 'ClientTheme',

  components: {
    ThemeEditor
  },

  methods: {
    ...mapActions({
      loadingDone: 'app/loadingDone'
    })
  },

  created () {
    this.loadingDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/ClientThemePage.vue